import { ValueOf } from 'type-fest';
import {
    ATTENDEE_PAYER,
    SERVICE_FEE_COMPONENT_NAME,
    TAX_COMPONENT_BASE_FEES_TAX_INCLUDABLE,
    TAX_PROCESSING_FEE_COMPONENT_NAME,
    TAX_SERVICE_FEE_COMPONENT_NAME,
    TICKET_CLASS_CATEGORIES,
} from '../constants';

export type TicketId = string;

export interface TicketVariant {
    code: string;
    discountType: string;
    percentOff?: string;
    amountOff?: {
        value: number;
        currency: string;
    };
    originalCost?: {
        value: number;
    };
}

export interface Ticket {
    category: ValueOf<typeof TICKET_CLASS_CATEGORIES>;
    isDisabled: boolean;
    variants: Array<TicketVariant>;

    cost: {
        value: number;
        currency: string;
    }; // TODO: find proper value
    currency: string;
    displayShippingFee: {
        value: number;
    };
    fee: {
        value: number;
    };
    free: boolean;
    selectedQuantity: number;
    tax: {
        value: number;
        taxBeforeExemption: number;
    };
    taxComponents?: Array<PriceComponent>;
    taxWithoutShipping?: {
        value: number;
    };

    feeComponents: Array<PriceComponent>;
}

export interface SelectedTicket {
    category: ValueOf<typeof TICKET_CLASS_CATEGORIES>;
    cost?: {
        value: number;
    };
    free: boolean;
    id: TicketId;
    name: string;
    selectedQuantity: number;
    color: string;
}

export interface PriceComponent {
    base: string;
    groupName: string;
    name: string;
    payer: string;
    value: number | { value: number };
    includesTax?: boolean;
}

export const getTaxOnFeeComponents = (
    feeComponents: Array<PriceComponent> = [],
    taxComponents: Array<PriceComponent>,
) => {
    const taxFeeComponents = feeComponents;
    const filteredTaxComponents = taxComponents.filter(
        (e) =>
            e.base === TAX_COMPONENT_BASE_FEES_TAX_INCLUDABLE ||
            ([
                TAX_SERVICE_FEE_COMPONENT_NAME,
                TAX_PROCESSING_FEE_COMPONENT_NAME,
            ].includes(e.groupName) &&
                e.payer == ATTENDEE_PAYER),
    );
    const feeTax = filteredTaxComponents.reduce(
        (total, component) => total + (component.value as number),
        0,
    );
    const esfComponent = taxFeeComponents.find(
        (e) => e.name === SERVICE_FEE_COMPONENT_NAME,
    );
    const index = taxFeeComponents.findIndex(
        (e) => e.name === SERVICE_FEE_COMPONENT_NAME,
    );

    // Only add tax to ESF component if not already included
    if (
        esfComponent &&
        !('includesTax' in esfComponent && esfComponent.includesTax)
    ) {
        (esfComponent.value as number) += feeTax as number;
        esfComponent.includesTax = true;
        taxFeeComponents.splice(index, 1);
        taxFeeComponents.push(esfComponent);
    }

    return taxFeeComponents;
};
